import React from "react";

const InvoiceModal = ({
  isOpenInvoiceModal,
  setIsOpenInvoiceModal,
  invoices,
}) => {

  return (
    <>
      {isOpenInvoiceModal && (
        <div
          style={{ zIndex: 9999 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        >
          <div className="bg-white w-[484px] max-w-md shadow-lg px-[42px] py-[56px] relative">
            <button
              className="absolute top-4 right-5 text-gray-500 hover:text-gray-700"
              onClick={() => setIsOpenInvoiceModal(false)}
            >
              &times;
            </button>

            <h2 className="text-xl font-semibold mb-[34px]">Monthly Invoice</h2>

            <div className="border-t !text-sm border-gray-200 pt-4 space-y-4">
              <div className="flex justify-between">
                <span className="text-gray-500">Due Date</span>

                <span className="text-gray-500">Invoice Number </span>
              </div>

              <div className="flex justify-between">
                <span>
                  {invoices?.dueDate || new Date().toLocaleDateString()}
                </span>

                <span className="font-medium">{invoices?.id || "000000"}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-500">Status</span>
                <span className="text-gray-500">Payment Method</span>
              </div>

              <div className="flex justify-between">
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-medium">
                  {invoices?.status}
                </span>

                <span>{invoices?.default_payment_method || "Unknown"}</span>
              </div>

              <hr className="mt-2 " />

              <div className="flex justify-between">
                <span className="text-gray-500 text-[12px]">Plan</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Starter</span>
                <span>${invoices?.amount_due || 0}</span>
              </div>

              <hr className="my-2" />

              <div className="flex justify-between">
                <span className="text-gray-500">Taxes</span>
                <span>${invoices?.tax || 0}</span>
              </div>

              <hr className="my-2" />

              <div className="flex justify-between font-semibold">
                <span className="text-gray-700">Total</span>
                <span>${invoices?.amount_due + invoices?.tax || 0}</span>
              </div>
            </div>

            <div className="mt-6 flex justify-center">
              <a
                href={invoices?.invoice_pdf}
                target="_blank"
                download={`invoice_${invoices?.id || "000000"}.pdf`}
                className="cursor-pointer w-full text-center bg-black text-white py-2 rounded-md hover:bg-gray-900 transition" rel="noreferrer"
              >
                Download PDF
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceModal;
